export const CFB_INTEGRATION_REGISTRATION_SESSION_KEY =
  'cfb-integration-registration';

export function isIntegrationRegistrationSessionActive(): boolean {
  return (
    sessionStorage.getItem(CFB_INTEGRATION_REGISTRATION_SESSION_KEY) === 'true'
  );
}

export function setIntegrationRegistrationSessionActive(
  isActive: boolean,
): void {
  if (isActive) {
    sessionStorage.setItem(CFB_INTEGRATION_REGISTRATION_SESSION_KEY, 'true');
    return;
  }

  sessionStorage.removeItem(CFB_INTEGRATION_REGISTRATION_SESSION_KEY);
}

export function isPublicRegistrationRoute(url: string): boolean {
  return url.includes('/public/registration');
}
